import React from 'react';
import { Tooltip } from 'react-tooltip';

import { useMouse } from '@hooks/useMouse';

import { selectAppLocationSelectValue } from '@store/useAppStore';
import { selectAppPersistMapsVisible } from '@store/useAppStorePersist';

import MapLegend from './components/MapLegend/MapLegend';
import MapTabs from './components/MapTabs/MapTabs';
import MapTooltipStatic from './components/MapTooltipStatic/MapTooltipStatic';
import SimpleMaps from './components/SimpleMaps/SimpleMaps';
import { useMapData } from './hooks/useMapData';
import style from './style.module.scss';

const Maps = () => {
  const [mouse, ref] = useMouse();
  const locationSelectValue = selectAppLocationSelectValue();

  useMapData(locationSelectValue.level_name === 'group' ? locationSelectValue.filterIds : []);

  const mapsVisible = selectAppPersistMapsVisible();

  if (!mapsVisible) {
    return null;
  }

  const MAP_MARKERS_TOOLTIP_ID = 'map-markers-tooltip';

  return (
    <div className={style.mapContainer} ref={ref}>
      <MapTabs />
      <MapLegend />
      <SimpleMaps tooltipId={MAP_MARKERS_TOOLTIP_ID} />
      <MapTooltipStatic id={MAP_MARKERS_TOOLTIP_ID} />
      <Tooltip id={MAP_MARKERS_TOOLTIP_ID} className={style.mapMarkersTooltip} float />
    </div>
  );
};

export default Maps;
